import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import "./style/vendors/custom-material.scss";
import 'sweetalert2/dist/sweetalert2.min.css';

import Axios from 'axios'
import VueApexCharts from "vue-apexcharts";
import VueQRCodeComponent from 'vue-qrcode-component'
import VueMaterial from 'vue-material'
import VueSweetalert2 from 'vue-sweetalert2';
import VueKonva from 'vue-konva'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

import moment from 'moment'
require('moment/locale/nl-be');
moment.locale('nl-be');
 
Vue.component("apexchart", VueApexCharts);
Vue.component('qr-code', VueQRCodeComponent)
Vue.use(VueMaterial)
Vue.use(VueApexCharts);
Vue.use(VueSweetalert2);
Vue.use(VueKonva)

Vue.prototype.$http = Axios;


Sentry.init({
  Vue,
  dsn: "https://437160f1b632495d983a8c3c59518442@o311820.ingest.sentry.io/5616531",
  integrations: [
    new Integrations.BrowserTracing(),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

Vue.directive('click-outside', {
  bind(el, binding, vnode) {
      var vm = vnode.context;
      var callback = binding.value;

      el.clickOutsideEvent = function (event) {
          if (!(el == event.target || el.contains(event.target))) {
              return callback.call(vm, event);
          }
      };
      document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
      document.body.removeEventListener('click', el.clickOutsideEvent);
  }
});


Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).add(1, 'hours').locale('nl-be').format('DD-MM-YYYY')
  }
});

Vue.filter('formatDateTime', function(value) {
  if (value) {
    return moment(String(value)).add(1, 'hours').locale('nl-be').format('DD-MM-YYYY  HH:mm')
  }
});

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'JWT ' + token
}

/**
 * Change in store.js too!
 */
// Vue.prototype.$endpoint = "http://localhost:3002/"
Vue.prototype.$endpoint = "https://surgitec-backend-sr7gh.ondigitalocean.app/" 

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
